import {SelectItem, SelectList, SelectPopover, SelectTrigger} from '@/components/ui/select-atoms/SelectAtoms'
import {SelectProvider} from '@ariakit/react'
import {formatLocaleDate} from '@/dayjs'
import {capitalize} from '@/utilities/helpers'
import dayjs from 'dayjs'
import {useDayPicker} from 'react-day-picker'

interface RangeCalendarMonthSelectProps {
    currentDate: Date
    onMonthChange: (date: Date) => void
}

export const RangeCalendarMonthSelect = ({currentDate, onMonthChange}: RangeCalendarMonthSelectProps) => {
    const {goToMonth} = useDayPicker()

    const getMonthOptions = (): [string, string][] => {
        return Array.from({length: 12}, (_, i) => {
            return [i.toString(), capitalize(formatLocaleDate(dayjs().month(i).toDate(), 'MMMM'))]
        })
    }

    const handleMonthChange = (value: string) => {
        const newMonth = parseInt(value, 10)
        const newDate = dayjs(currentDate).month(newMonth).toDate()
        onMonthChange(newDate)
        goToMonth(newDate)
    }

    const currentMonth = dayjs(currentDate).month().toString()

    return (
        <SelectProvider value={currentMonth} setValue={handleMonthChange}>
            <SelectTrigger
                style={{width: '110px', outline: 'none', boxShadow: 'none'}}
                value={currentMonth}
                displayValue={() =>
                    capitalize(formatLocaleDate(dayjs().month(parseInt(currentMonth)).toDate(), 'MMMM'))
                }
            />
            <SelectPopover>
                <SelectList>
                    {getMonthOptions().map(([value, label]) => (
                        <SelectItem key={value} value={value} hasItemCheckbox={false}>
                            {label}
                        </SelectItem>
                    ))}
                </SelectList>
            </SelectPopover>
        </SelectProvider>
    )
}
